export default __webpack_public_path__ + "static/media/sopimus-black.3609a345.svg";